// extracted by mini-css-extract-plugin
export default {"root":"fau3Vu","root-missing-wix-header":"qqJLeA","rootMissingWixHeader":"qqJLeA"};